---
title: "Benutzerrollen"
slug: user-roles
description: "hey circle hat drei Benutzerrollen: Company Admin, Company Manager und Scanner — mit klaren Berechtigungen."
keywords:
  - Benutzerrollen
  - Berechtigungen
  - Admin
  - Manager
  - Scanner
  - Zugriff
  - Nutzerverwaltung
---

## Die drei Benutzerrollen

hey circle unterscheidet drei Rollen für Benutzer Ihres Unternehmens. Welche Aktionen ein Benutzer ausführen kann, hängt ausschließlich von seiner Rolle ab.

### Company Admin

Der Company Admin hat vollen Zugriff auf alle Funktionen der Plattform. Er ist typischerweise die Person, die das Unternehmen eingerichtet hat oder für Einstellungen und Abrechnung verantwortlich ist.

### Company Manager

Der Company Manager kann den operativen Betrieb verwalten: Standorte einrichten, externe Empfänger anlegen und Analysen einsehen. Er kann jedoch keine Benutzer verwalten, Integrationen konfigurieren oder Abrechnungen einsehen.

### Scanner

Der Scanner führt die tägliche Arbeit aus: Pakete senden und empfangen. Er hat keinen Zugriff auf Standortverwaltung, Analysen oder andere Verwaltungsbereiche.

## Berechtigungsübersicht

| Berechtigung | Company Admin | Company Manager | Scanner |
|---|:---:|:---:|:---:|
| Benutzer verwalten | ✅ | | |
| Integrationen verwalten (Shopify) | ✅ | | |
| Billing | ✅ | | |
| Standorte anlegen / bearbeiten | ✅ | ✅ | |
| Externe Empfänger anlegen / bearbeiten | ✅ | ✅ | |
| Analysen einsehen | ✅ | ✅ | |
| Pakete scannen (Senden / Empfangen) | ✅ | ✅ | ✅ |
| Inventarliste einsehen | ✅ | ✅ | ✅ |
| Verträge einsehen | ✅ | ✅ | |

## Rollen zuweisen

Rollen werden beim Einladen eines Benutzers festgelegt. Nur ein **Company Admin** kann Benutzer einladen und Rollen ändern.

Die Rollenzuweisung erfolgt im oberen Menü unter **Einstellungen → Benutzer**. Dort können Sie bestehende Benutzer bearbeiten und Scanner einem oder mehreren Standorten zuordnen.

Weitere Details zur Einrichtung finden Sie im Artikel [Ersteinrichtung](/app/help?article=initial-setup).

## Verwandte Artikel

- [Ersteinrichtung](/app/help?article=initial-setup)
- [Interne vs. externe Standorte](/app/help?article=internal-vs-external-locations)
